
function getPlaylistById(playlistId) {
  return videoData.playlists.filter((playlist) => playlist.id == playlistId);
}

function getVideoById(videoId) {
  for (let i = 0; i < videoData.playlists.length; i++) {
    const [video] = videoData.playlists[i].videos.filter(
      (video) => video.id == videoId
    );
    if (video) {
      return video;
    }
  }
}

function getVideoByPlaylistId(playlistId, videoId) {
  const [playlist] = getPlaylistById(playlistId);
  if (playlist) {
    return playlist.videos.filter((video) => video.id == videoId);
  }
}


function getPlayListByVideoid(videoId) {
  for (let i = 0; i < videoData.playlists.length; i++) {
    const [video] = videoData.playlists[i].videos.filter(
      (video) => video.id == videoId
    );
    if (video) {
      return videoData.playlists[i];
    }
  }
}
$(document).ready(function() {
  // Function to get URL parameters
  function getQueryParam(param) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
  }
  const pathname = window.location.pathname;

  // Check if 'theme' parameter is set to 'dark'
  window.theme = getQueryParam('theme');
  if(pathname === '/pro-learn/' || pathname === '/pro-learn-details/'){
    if (window.theme === 'dark') {
        $('body').addClass('dark');
    }
  }
});

